"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wallet = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Wallet = function Wallet() {
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5 6.167h15.167A2.333 2.333 0 0122.5 8.5v11.667a2.333 2.333 0 01-2.333 2.333H3.833A2.333 2.333 0 011.5 20.167V5A3.5 3.5 0 015 1.5h12.833a2.333 2.333 0 012.334 2.333H5a1.167 1.167 0 000 2.334zM11.813 18h8.437v-7.5h-8.438c-.724 0-1.312.56-1.312 1.25v5c0 .69.588 1.25 1.313 1.25z",
    clipRule: "evenodd"
  }), react_1.default.createElement("path", {
    fill: "currentColor",
    d: "M13.5 15.75H15a.75.75 0 00.75-.75v-1.5a.75.75 0 00-.75-.75h-1.5a.75.75 0 00-.75.75V15c0 .414.336.75.75.75z",
    opacity: "0.72"
  }));
};

exports.Wallet = Wallet;